export default __webpack_public_path__ + "static/media/79899c6efbd91c9a0ebdd970e3fff5c5.svg";